export default __webpack_public_path__ + "in-mall-support-icon-smo.bfa1bff5f8b349e80f7a786ecf918a1b.png";